import React from 'react'

export function useMountCallback(callback: React.EffectCallback) {
    const ref = React.useRef(true)
    // biome-ignore lint/correctness/useExhaustiveDependencies: run only on mount
    React.useEffect(() => {
        if (ref.current) {
            callback()
            ref.current = false
        }
    }, [])
}

export function useUnmountCallback(callback: () => void) {
    const ref = React.useRef(true)
    // biome-ignore lint/correctness/useExhaustiveDependencies: run only on mount
    React.useEffect(
        () => () => {
            if (ref.current) {
                callback()
                ref.current = false
            }
        },
        []
    )
}
